import { useEffect } from "react";
import { Header, NAV } from "./Header";
import { Hero } from "./Hero";
import { Accommodations } from "./Accommodations";
import { Gallery } from "./Gallery";
import { Features } from "./Features";
import { Location } from "./Location";
import { Footer } from "./Footer";
import { FloatingButtons } from "./FloatingButtons";

const setMeta = (name, value) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value || "");
};

export const SiteView = ({ content, headerTop = 0 }) => {
  const s = content.settings;
  const nav = NAV.filter((n) => (n.href !== "#diferenciais" || content.features.length) && (n.href !== "#galeria" || content.gallery.length));
  useEffect(() => {
    if (s.seo_title) document.title = s.seo_title;
    setMeta("description", s.seo_description);
  }, [s.seo_title, s.seo_description]);

  return (
    <div className="bg-[#08080A] text-[#FAFAFA] overflow-x-hidden" data-testid="site-view">
      <Header top={headerTop} nav={nav} />
      <main>
        <Hero s={s} />
        <Accommodations s={s} rooms={content.accommodations} />
        <Gallery s={s} items={content.gallery} />
        <Features s={s} items={content.features} />
        <Location s={s} />
      </main>
      <Footer s={s} nav={nav} />
      <FloatingButtons s={s} />
    </div>
  );
};
